// extracted by mini-css-extract-plugin
module.exports = {"content":"CustomDialogContent_content__1jCii","block":"CustomDialogContent_block__2K6dC","flex":"CustomDialogContent_flex__2re0K","padded":"CustomDialogContent_padded__adSvC"};